import { fetchAPI } from '../utils/api';
import { DEFAULT_PER_PAGE } from 'constants/PAGINATION';

export const searchForFavourite = (query: string) =>
  fetchAPI(`/channels/catalog?q=${query}`, {
    version: '1.2',
  }).then(r => r.json());

export const addDataItemToFavourite = (items: DataItem[]): Promise<boolean> =>
  fetchAPI('/self/data_item/favourite', {
    method: 'POST',
    version: '1.2',
    payload: {
      ids: items.map(x => x.id),
    },
  }).then(r => r.ok);

export const addShopItemToFavourite = (items: ShopItem[]): Promise<boolean> =>
  fetchAPI('/self/shop_item/favourite', {
    method: 'POST',
    version: '1.2',
    payload: {
      ids: items.map(x => x.id),
    },
  }).then(r => r.ok);

export const removeDataItemFromFavourite = (
  items: DataItem[]
): Promise<boolean> =>
  fetchAPI('/self/data_item/favourite', {
    method: 'DELETE',
    version: '1.2',
    payload: {
      ids: items.map(x => x.id),
    },
  }).then(r => r.ok);

export const removeShopItemFromFavourite = (
  items: ShopItem[]
): Promise<boolean> =>
  fetchAPI('/self/shop_item/favourite', {
    method: 'DELETE',
    version: '1.2',
    payload: {
      ids: items.map(x => x.id),
    },
  }).then(r => r.ok);

export const fetchFavouriteShopItem = (payload: {
  page?: number;
  keyword?: string;
}): Promise<{
  items: ShopItem[];
  total: number;
}> => {
  return fetchAPI('/self/shop_item', {
    version: '1.2',
    payload: {
      ...payload,
    },
  }).then(r => r.json());
};

export type DataItemFiltersProps = {
  trade_term?: string[];
  packaging_type?: string[];
  latest_price?: string[];
};
export const fetchFavouriteDataItem = (payload: {
  page?: number;
  per_page?: number;
  keyword?: string;
  exclude_ids?: number[];
  only_subscribed?: boolean;
  sorts?: {
    field: string;
    order: string;
  }[];
  filters?: DataItemFiltersProps;
}): Promise<DataItemViewResponse> => {
  const per_page = payload.per_page ? payload.per_page : DEFAULT_PER_PAGE;
  return fetchAPI('/self/data_item', {
    version: '1.2',
    method: 'POST',
    payload: { ...payload, per_page },
  }).then(r => r.json());
};

export const checkPrepopulate = () =>
  fetchAPI('/self/check_prepopulate', {
    method: 'GET',
    version: '1.2',
  }).then(res => res.json());

export const fetchSubscribedShopItemCategory = (payload: {
  page?: number;
  per_page?: number;
  keyword?: string;
}): Promise<{
  items: ShopItemCategory[];
  total: number;
}> => {
  return fetchAPI('/self/shop_item_category', {
    version: '1.2',
    payload: {
      ...payload,
    },
  }).then(r => r.json());
};



// WEBPACK FOOTER //
// ./app/api/favourite.ts